import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  lookingForChallengePrompt: {
    id: 'Dashboard.NoCoursesView.lookingForChallengePrompt',
    defaultMessage: 'Looking for a new challenge?',
    description: 'Prompt user for new challenge',
  },
  exploreCoursesPrompt: {
    id: 'Dashboard.NoCoursesView.exploreCoursesPrompt',
    defaultMessage: 'Explore our courses to add them to your dashboard.',
    description: 'Prompt user to explore more courses',
  },
  exploreCoursesButton: {
    id: 'Dashboard.NoCoursesView.exploreCoursesButton',
    defaultMessage: 'Explore courses',
    description: 'Button to explore more courses',
  },
  bannerAlt: {
    id: 'Dashboard.NoCoursesView.bannerAlt',
    defaultMessage: 'No Courses view banner',
    description: 'No Courses view basnner',
  },
});

export default messages;
